
import modalMixin from "./mixin";
import SearchFilterEditor from "../SearchFilterEditor.vue";
import { Component, Mixins } from "vue-property-decorator";
import { getModule } from "vuex-module-decorators";
import { OrderModule } from "@/store/modules";
import * as modals from "@/lib/modals";

@Component({
  name: modals.advancedSearchModal,
  components: { SearchFilterEditor }
})
export default class AdvancedSearchModal extends Mixins(modalMixin) {
  filter: any = null;
  orderModule: OrderModule = getModule(OrderModule);

  get existingAdvancedSearchFilter() {
    return this.orderModule.advancedSearchFilter;
  }

  load() {
    this.filter = JSON.parse(JSON.stringify(this.existingAdvancedSearchFilter));
  }

  executeSearch(filter) {
    this.orderModule.setAdvancedSearchFilter(filter);
    if (this.$router.currentRoute.name !== "AdvancedSearchResults") {
      this.$router.push({ name: "AdvancedSearchResults" }).catch(ex => {
        console.error("ERROR: Advanced search results, ex: " + ex);
      });
    }
    this.load();
    this.hideModal();
    this.orderModule.reloadAdvancedSearchResults({ page: 1 });
  }

  reset() {
    this.filter = null;
  }
}
